import { render, staticRenderFns } from "./SiblingsDetails.vue?vue&type=template&id=eb49aea4&scoped=true"
import script from "./SiblingsDetails.vue?vue&type=script&lang=js"
export * from "./SiblingsDetails.vue?vue&type=script&lang=js"
import style0 from "./SiblingsDetails.vue?vue&type=style&index=0&id=eb49aea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb49aea4",
  null
  
)

export default component.exports